import React, { useState, useEffect } from "react";
import FooterLogo from "./../assets/nexus_logo.webp";
import { HEADER_COLOR, PRIMARY_COLOR } from "../constants/theme";
import { Link, useNavigate } from "react-router";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [screenWidth, setScreenWidth] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const handleSubmit = async () => {
    if (!email) {
      toast.error("Email is required!");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email.trim())) {
      toast.error("Email address is invalid");
      return;
    }
    //api here

    navigate("/forgot-password-otp");
  };

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        backgroundColor: "#fae5ff",
      }}
    >
      <div
        className=""
        style={{
          position: "absolute",
          left: "50%",
          top: "0",
          height: "605px",
          width: "165vw",
          borderRadius: "50%",
          transform: "translateX(-50%) translateY(-460px)",
          backgroundColor: "rgb(203, 108, 230)",
          zIndex: "0",
        }}
      ></div>

      <div
        className="d-flex flex-column justify-content-evenly align-items-center"
        style={{
          minHeight: "145px",
          paddingBottom: "18px",
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          // paddingTop: '15px'
        }}
      >
        <div
          className=""
          style={{
            color: "#fae5ff",
            fontSize: "38px",
            fontWeight: "600",
          }}
        >
          SmileApp
        </div>
      </div>

      <div
        className="row w-100 mx-auto flex-column justify-content-between align-items-center position-relative"
        style={{
          minHeight: "100dvh",
          // backgroundColor: '#fae5ff'
        }}
      >
        <div
          className="col-12 p-0"
          style={{
            height: "65.5px",
          }}
        ></div>

        <div className="col-12 p-0">
          <div
            className="text-center"
            style={{
              fontSize: "24px",
              color: HEADER_COLOR,
              fontWeight: "600",
              marginBottom: "20px",
            }}
          >
            Forgot Password
          </div>
          <div
            className="row w-100 h-100 mx-auto flex-column align-items-center justify-content-center"
            style={{
              // minHeight: '55vh',
              gap: "35px",
              // paddingTop: '100px'
            }}
          >
            <div className="col-12 p-0">
              <div className="row w-100 mx-auto align-items-center justify-content-center">
                <div className="col-12 p-0">
                  <div className="row w-100 mx-auto align-items-center justify-content-center">
                    <div
                      className="col-auto p-0 d-flex flex-column align-items-start justify-content-center"
                      style={{
                        width: "100%",
                        maxWidth: screenWidth >= 576 ? "310px" : "250px",
                      }}
                    >
                      <label
                        for="forgotPasswordEmail"
                        className="text-start form-label"
                        style={{
                          fontSize: "13.5px",
                          marginLeft: "4px",
                          marginBottom: "3px",
                          fontWeight: "500",
                          color: PRIMARY_COLOR,
                        }}
                      >
                        Email
                      </label>

                      <input
                        className="login-input text-start"
                        id="forgotPasswordEmail"
                        type="text"
                        placeholder="Enter Your Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{
                          border: "2px solid rgb(203, 108, 230)",
                          borderRadius: "10px",
                          padding: "8px 12px",
                          backgroundColor: "rgb(255,255,255)",
                          outline: "none",
                          // width: '250px',
                          width: "100%",
                          fontWeight: "400",
                          color: HEADER_COLOR,
                          letterSpacing: "0.01ch",
                          fontSize: "13.5px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 p-0">
              <div
                className="row w-100 mx-auto flex-column align-items-center justfy-content-center"
                style={{
                  gap: "6px",
                  width: "100%",
                  maxWidth: screenWidth >= 576 ? "310px" : "250px",
                }}
              >
                <div className="col-12 p-0">
                  <button
                    className="btn "
                    style={{
                      // backgroundColor: 'rgb(203, 108, 230)',
                      // color: '#fae5ff',
                      // width: '250px',
                      backgroundColor: "rgb(203, 108, 230)",
                      color: "#fae5ff",
                      width: "100%",
                      // maxWidth: screenWidth >= 576 ? '310px' : '250px',
                      borderRadius: "10px",
                      // height: '44px',
                      fontSize: "13.5px",
                      padding: "8.5px 12px",
                    }}
                    onClick={handleSubmit}
                  >
                    Recover Password
                  </button>
                </div>

                <div className="col-12 p-0">
                  <Link
                    to="/login"
                    className="btn btn-light"
                    style={{
                      // width: '250px',
                      border: "0.5px solid silver",
                      width: "100%",
                      borderRadius: "10px",
                      // height: '44px',
                      fontSize: "13.5px",
                      padding: "8px 12px",
                    }}
                    onClick={(e) => navigate("/login")}
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-12 p-0"
          style={
            {
              // marginTop: '35px'
            }
          }
        >
          <div
            className="row w-100 h-100 mx-auto align-items-center justify-content-center"
            style={{
              // minHeight: '15vh',
              padding: "0 0 20px 0",
            }}
          >
            <div className="col-auto p-0">
              <img
                className=""
                src={FooterLogo}
                alt="footer logo"
                style={{
                  width: "85px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
